export const CHOICES_ALIASES = [
  {
    id: 91,
    name: 'ohne',
    choices: [{
      id: 'com.ptc.windchill.option.model.Choice.1448446860',
      id2: '0P4EW',
      name: 'Ohne Kraftstofftank, rechts (Tankvolumen)',
      numericValue: 0,
      optionId: 'com.ptc.windchill.option.model.Option.4134780300',
      optionId2: '0KOC',
      optionName: 'Tankvolumen Kraftstoff rechts',
      type: 'NUMERIC'
    }]
  },
  {
    id: 107,
    name: 'Struktur',
    choices: [{
      id: 'com.ptc.windchill.option.model.Choice.1638413791',
      id2: '0P6X5',
      name: 'Strukturlackierung Dachspoiler',
      numericValue: 0,
      optionId: 'com.ptc.windchill.option.model.Option.1638413780',
      optionId2: '0KQM',
      optionName: 'Lackierung Dachspoiler/Aeropaket',
      type: 'NUMERIC'
    }]
  }
]
export const ALIASES = [
  {
    id: 85,
    name: 'Doppeltank re ( mit / ohne)',
    description: 'Doppeltank / Einzeltank',
    choicesAliases: CHOICES_ALIASES,
    option: null
  },
  {
    id: 104,
    name: 'Dachspoiler Struktur / Lack / ohne',
    description: null,
    choicesAliases: null,
    option: {
      categoryId: 'com.ptc.windchill.option.model.Group.2295398358',
      categoryName: 'Fahrerhaus und Fahrerhaus Exterieur',
      id: 'com.ptc.windchill.option.model.Option.1638413780',
      id2: '0KQM',
      name: 'Lackierung Dachspoiler/Aeropaket'
    }
  }
]
